import { render, staticRenderFns } from "./JdSkuInfoCard.vue?vue&type=template&id=94d16230&scoped=true&"
import script from "./JdSkuInfoCard.vue?vue&type=script&lang=js&"
export * from "./JdSkuInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./JdSkuInfoCard.vue?vue&type=style&index=0&id=94d16230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d16230",
  null
  
)

export default component.exports